export function carousels(_sel) {
    if (_sel.children.length > 1) {
        const config = {
            cellAlign: 'center',
            wrapAround: true,
            draggable: true,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: 6000,
            lazyLoad: true
        };

        if (_sel.classList.contains('site-masthead__images')) {
            config.setGallerySize = false;
        }

        let carousel = new Flickity(_sel, config);
    }
}